import React, {useState} from 'react';

const ClientTab = (props) => {
  return (
    <>Client Tab</>
  )
}

export default ClientTab
